import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import {DataManagementService} from '../../services/data-management.service';
import {Constants} from '../../constants';
import * as XLSX from 'xlsx';
import {AccessService} from '../../services/access.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-outgoing-term-schedule',
  templateUrl: './outgoing-term-schedule.component.html',
  styleUrls: ['./outgoing-term-schedule.component.css']
})
export class OutgoingTermScheduleComponent implements OnInit {
  @ViewChild('addEditTermModal') addEditTermModal: TemplateRef<any>;
  @ViewChild('studentsModal') studentsModal: TemplateRef<any>;
  @ViewChild('universitiesModal') universitiesModal: TemplateRef<any>;
  @ViewChild('uploadTermSettingsModal') uploadTermSettingsModal: TemplateRef<any>;
  public modalReference: NgbModalRef;
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  data: object;
  outgoingStudents;
  outgoingTermSettings;
  academicYear;
  outgoingTermName;
  minWorkExperience = 0;
  minCgpa;
  academicYearId;
  outgoingTermId;
  outgoingStudentsBackupObject = {};
  universitiesBackupObject = {};
  checkedStudents = [];
  checkedUniversities = [];
  universities;
  errorMessage: string = undefined;
  outgoingStudentsErrorMessage: string = undefined;
  universitiesErrorMessage: string = undefined;
  selectUndefinedOptionValue = undefined;
  programmes;
  editTermFlag;
  changeStudentFilterObj;
  programmeName;
  batch;
  batches;
  registrationEndTime;
  registrationStartTime;

  constructor(private modal: NgbModal,
              private dmService: DataManagementService,
              private router: Router,
              private accessService: AccessService) { }

  getTermSettings() {
    this.dmService.getAll(Constants.TERM_SETTINGS)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.outgoingTermSettings = response.data.outgoing_terms;
                this.academicYear = response.data.academic_year;
                this.batches = response.data.batches;
                if (this.outgoingTermSettings.length === 0) {
                  this.errorMessage = 'There is no data available for Term Settings.';
                } else {
                    this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getProgrammes() {
    this.dmService.getAll(Constants.PROGRAMMES)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.programmes = response.data;
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  fileChange(evt) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot upload multiple files on the entry');
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {type: 'binary'});
      /* grab first sheet */
      const wsName = wb.SheetNames[0];
      const ws = wb.Sheets[wsName];
      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws,
          {header: ['academic_year', 'outgoing_term_code', 'outgoing_term_name', 'registration_start_time',
                  'registration_end_time'], range: 1});
    };
    reader.readAsBinaryString(target.files[0]);
    return this.data;
  }

  openTermSettingsUploadModal() {
    this.modalReference = this.modal.open(this.uploadTermSettingsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  uploadTermSettings(e) {
    e.preventDefault();
      const finalUploadData = {
      data: this.data,
      user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
    };
    const that = this;
    let uploadResponse;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to upload ' + Object.keys(this.data).length + ' Term Settings?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(finalUploadData, Constants.TERM_SETTINGS).subscribe(data => {
            uploadResponse = data;
            resolve(uploadResponse);
          }, error => {
            uploadResponse = error;
            reject(uploadResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (uploadResponse.status === 'success') {
          that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
              that.router.navigate(['term-schedule/outgoing']));
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({
              title: 'Success',
              type: 'success',
              html: uploadResponse.data.message,
            });
          } else {
            Swal({
              title: 'Success',
              type: 'success',
              html: '<p>Successfully uploaded Term Settings.</p>',
            });
          }
          that.closeModal();
        } else if (uploadResponse.status === 'fail') {
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({type: 'error', title: 'Fail', html: uploadResponse.data.message});
          } else {
            Swal({type: 'error', title: 'Fail', text: 'Unable to upload Term Settings, Please contact support team.'});
          }
        }
      }
    }).catch(errors => {
      Swal({type: 'error', title: 'Fail', text: 'Server Error: ' + errors.message});
    });
  }

  openAddTermSettingsModal() {
    this.editTermFlag = false;
    this.dmService.getAll(Constants.ADD_TERM_SETTINGS).subscribe(responseData => {
          if (responseData.status === 'success') {
            this.outgoingStudents = responseData.data.outgoingStudents;
            this.universities = responseData.data.universities;
            this.changeStudentFilterObj = responseData.data.outgoingStudents;
            if (this.outgoingStudents.length === 0) {
              this.outgoingStudentsErrorMessage = 'There is no data available for outgoing students.';
            }
            if (this.universities.length === 0) {
              this.universitiesErrorMessage = 'There is no data available for universities.';
            }
          } else if (responseData.status === 'fail') {
            if (responseData.data.hasOwnProperty('message')) {
              this.outgoingStudentsErrorMessage = responseData.data.message;
            } else {
              this.outgoingStudentsErrorMessage = 'Something went wrong. Please contact support team';
            }
          }
        },
        error => {
          console.log(error);
          this.outgoingStudentsErrorMessage = 'Server Error';
        });
    this.modalReference = this.modal.open(this.studentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  openEditTermSettingsModal(term) {
    this.editTermFlag = true;
    this.outgoingTermId = term.outgoing_term_id;
    this.outgoingTermName = term.outgoing_term_name;
    this.minCgpa = term.min_cgpa;
    this.academicYearId = term.academic_year_id;
    this.minWorkExperience = term.min_work_experience;
    this.registrationStartTime = this.getDateTimeForForm(term.registration_start_time);
    this.registrationEndTime = this.getDateTimeForForm(term.registration_end_time);
    this.dmService.getOne(Constants.EDIT_TERM_SETTINGS, term.outgoing_term_id).subscribe(responseData => {
          if (responseData.status === 'success') {
            this.outgoingStudents = responseData.data.all_outgoing_students;
            this.universities = responseData.data.all_universities;
            this.changeStudentFilterObj = responseData.data.all_outgoing_students;
            this.checkedStudents = responseData.data.term_outgoing_students;
            this.checkedUniversities = responseData.data.term_universities;
            if (this.outgoingStudents.length === 0) {
              this.outgoingStudentsErrorMessage = 'There is no data available for outgoing students.';
            }
            if (this.universities.length === 0) {
              this.universitiesErrorMessage = 'There is no data available for universities.';
            }
            for (let i = 0; i < this.checkedStudents.length; i++) {
              this.outgoingStudentsBackupObject[this.checkedStudents[i].outgoing_student_id] = true;
            }
            for (let i = 0; i < this.checkedUniversities.length; i++) {
              this.universitiesBackupObject[this.checkedUniversities[i].university_id] = true;
            }
          } else if (responseData.status === 'fail') {
            if (responseData.data.hasOwnProperty('message')) {
              this.outgoingStudentsErrorMessage = responseData.data.message;
            } else {
              this.outgoingStudentsErrorMessage = 'Something went wrong. Please contact support team';
            }
          }
        },
        error => {
          console.log(error);
          this.outgoingStudentsErrorMessage = 'Server Error';
        });
    this.modalReference = this.modal.open(this.studentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  programmeChange(obj): void {
    this.outgoingStudents = [];
    if (this.programmeName === 'undefined') {
      this.programmeName = undefined;
    }
    if (this.batch === 'undefined') {
      this.batch = undefined;
    }
    for (let i = 0; i < obj.length; i++) {
      if ((obj[i].programme_name === this.programmeName || this.programmeName === undefined) &&
          (obj[i].batch === this.batch || this.batch === undefined)) {
        this.outgoingStudents.push(obj[i]);
      }
    }
    if (this.outgoingStudents.length === 0) {
      this.outgoingStudentsErrorMessage = 'There are no students available';
    }
    return;
  }

  addOrEditTerm(): void {
    if (this.editTermFlag === true) {
      this.editTerm();
    } else if (this.editTermFlag === false) {
      this.addTerm();
    }
  }

  addTerm() {
    let addTermResponse;
    const that = this;
    const studentIdsArray = [], universityIdsArray = [];
    for (let i = 0; i < this.checkedStudents.length; i++) {
      studentIdsArray.push(this.checkedStudents[i].outgoing_student_id);
    }
    for (let i = 0; i < this.checkedUniversities.length; i++) {
      universityIdsArray.push(this.checkedUniversities[i].university_id);
    }
    const data = {
      outgoing_term_name: this.outgoingTermName,
      universities: universityIdsArray,
      outgoing_students: studentIdsArray,
      academic_year_id: this.academicYearId,
      min_cgpa: this.minCgpa,
      min_work_experience: this.minWorkExperience,
      registration_end_time: this.registrationEndTime,
      registration_start_time: this.registrationStartTime
    };
    Swal({
      type: 'question',
      title: 'Confirm',
      html: '<p>You are going to add <span style="font-weight: bold">' + data.outgoing_students.length +
          '</span> outgoing students and <span style="font-weight: bold">' + data.universities.length +
          '</span> universities to term <span style="font-weight: bold">' + data.outgoing_term_name + '</span> ?</p>',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(data, Constants.ADD_TERM_SETTINGS).subscribe(resData => {
            addTermResponse = resData;
            resolve(addTermResponse);
          }, error => {
            addTermResponse = error;
            reject(addTermResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.hasOwnProperty('value')) {
        if (addTermResponse.status === 'success') {
          Swal({
            type: 'success',
            title: 'Success',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: '<p>Successfully added Term Settings.</p>',
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
          that.closeModal();
          that.getTermSettings();
        } else if (addTermResponse.status === 'fail') {
          Swal({
            type: 'error',
            title: 'Fail',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: '<p>Unable to add Term Settings, ' + addTermResponse.data.message + '</p>',
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
        }
      }
    }, function (cancel) {
      console.log(cancel);
    });
  }

  editTerm() {
    let editTermResponse;
    const that = this;
    const studentIdsArray = [], universityIdsArray = [];
    for (let i = 0; i < this.checkedStudents.length; i++) {
      studentIdsArray.push(this.checkedStudents[i].outgoing_student_id);
    }
    for (let i = 0; i < this.checkedUniversities.length; i++) {
      universityIdsArray.push(this.checkedUniversities[i].university_id);
    }
    const data = {
      outgoing_term_id: this.outgoingTermId,
      outgoing_term_name: this.outgoingTermName,
      universities: universityIdsArray,
      outgoing_students: studentIdsArray,
      min_cgpa: this.minCgpa,
      academic_year_id: this.academicYearId,
      min_work_experience: this.minWorkExperience,
      registration_start_time: this.registrationStartTime,
      registration_end_time: this.registrationEndTime
    };
    Swal({
      type: 'question',
      title: 'Confirm',
      html: '<p>You are going to update <span style="font-weight: bold">' + data.outgoing_students.length +
          '</span> outgoing students and <span style="font-weight: bold">' + data.universities.length +
          '</span> universities to term <span style="font-weight: bold">' + data.outgoing_term_name + '</span> ?</p>',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(data, Constants.EDIT_TERM_SETTINGS).subscribe(resData => {
            editTermResponse = resData;
            resolve(editTermResponse);
          }, error => {
            editTermResponse = error;
            reject(editTermResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (editTermResponse.status === 'success') {
          let responseMessage = '';
          if (editTermResponse.data.hasOwnProperty('message')) {
            responseMessage = editTermResponse.data.message;
          } else {
            responseMessage = 'Successfully updated Round Settings.';
          }
          Swal({
            type: 'success',
            title: 'Success',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: responseMessage,
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
          that.closeModal();
          that.getTermSettings();
        } else if (editTermResponse.status === 'fail') {
          Swal({
            type: 'error',
            title: 'Fail',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: '<p>Unable to updated Term Settings, ' + editTermResponse.data.message + '</p>',
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
        }
      }
    }, function (cancel) {
      console.log(cancel);
    });
  }

  saveStudents(): void {
    this.modalReference.close();
    this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  saveUniversities(): void {
    this.modalReference.close();
    this.modalReference = this.modal.open(this.addEditTermModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  backToStudents(): void {
    this.modalReference.close();
    this.modalReference = this.modal.open(this.studentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  backToUniversities(): void {
    this.modalReference.close();
    this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  clearStudents(): void {
    for (let i = 0; i < this.outgoingStudents.length; i++) {
      for (let j = 0; j < this.checkedStudents.length; j++) {
        if (this.checkedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
          delete this.outgoingStudentsBackupObject[this.checkedStudents[j].outgoing_student_id];
          this.checkedStudents.splice(this.checkedStudents.indexOf(this.checkedStudents[j]), 1);
        }
      }
    }
  }

  selectStudents(): void {
    this.clearStudents();
    for (let i = 0; i < this.outgoingStudents.length; i++) {
      this.outgoingStudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
      this.checkedStudents.push({
        'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
        'registration_id': this.outgoingStudents[i].registration_id,
        'name': this.outgoingStudents[i].name,
        'email': this.outgoingStudents[i].email,
        'programme_name': this.outgoingStudents[i].programme_name,
      });
    }
  }

  clearUniversities(): void {
    for (let i = 0; i < this.universities.length; i++) {
      for (let j = 0; j < this.checkedUniversities.length; j++) {
        if (this.checkedUniversities[j].university_id === this.universities[i].university_id) {
          delete this.universitiesBackupObject[this.checkedUniversities[j].university_id];
          this.checkedUniversities.splice(this.checkedUniversities.indexOf(this.checkedUniversities[j]), 1);
        }
      }
    }
  }

  selectUniversities(): void {
    this.clearUniversities();
    for (let i = 0; i < this.universities.length; i++) {
      if (this.universities[i].outgoing_count !== 0) {
        this.universitiesBackupObject[this.universities[i].university_id] = true;
      }
      this.checkedUniversities.push({
        'university_id': this.universities[i].university_id,
        'university_name': this.universities[i].university_name,
      });
    }
  }

  toggleStudent(isChecked, student: any) {
    if (isChecked === true) {
      this.outgoingStudentsBackupObject[student.outgoing_student_id] = true;
      this.checkedStudents.push({
        'outgoing_student_id': student.outgoing_student_id,
        'registration_id': student.registration_id,
        'name': student.name,
        'email': student.email
      });
    } else {
      for (let i = 0; i < this.checkedStudents.length; i++) {
        if (this.checkedStudents[i].outgoing_student_id === student.outgoing_student_id) {
          delete this.outgoingStudentsBackupObject[this.checkedStudents[i].outgoing_student_id];
          this.checkedStudents.splice(this.checkedStudents.indexOf(this.checkedStudents[i]), 1);
        }
      }
    }
  }

  toggleUniversity(isChecked, university: any) {
    if (isChecked === true) {
      this.universitiesBackupObject[university.university_id] = true;
      this.checkedUniversities.push({
        'university_id': university.university_id,
        'university_name': university.university_name
      });
    } else {
      for (let i = 0; i < this.checkedUniversities.length; i++) {
        if (this.checkedUniversities[i].university_id === university.university_id) {
          delete this.universitiesBackupObject[this.checkedUniversities[i].university_id];
          this.checkedUniversities.splice(this.checkedUniversities.indexOf(this.checkedUniversities[i]), 1);
        }
      }
    }
  }

  getDateTime(dateTime): string {
    if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
      return '';
    }
    return moment(dateTime).subtract(330, 'minutes').format('Do MMM YYYY , hh:mm a');
  }

  getDateTimeForForm(dateTime): string {
    if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
      return '';
    }
    return moment(dateTime).subtract(330, 'minutes').format('YYYY-MM-DDTHH:mm');
  }

  closeModal(): void {
    this.outgoingTermName = undefined;
    this.outgoingStudentsBackupObject = {};
    this.universitiesBackupObject = {};
    this.checkedStudents = [];
    this.outgoingStudents = [];
    this.universities = [];
    this.checkedUniversities = [];
    this.registrationStartTime = undefined;
    this.registrationEndTime = undefined;
    this.universitiesErrorMessage = undefined;
    this.outgoingStudentsErrorMessage = undefined;
    this.minCgpa = undefined;
    this.academicYearId = undefined;
    this.programmeName = undefined;
    this.batch = undefined;
    this.minWorkExperience = 0;
    this.modalReference.close();
  }


  clearRanks(term: any) {
    let clearResponse;
    const that = this;
    const body = {
      outgoing_term_id: term.outgoing_term_id,
      user_id : JSON.parse(localStorage.getItem('epas_user')).user_id
    };
    console.log(body);
    Swal({
      type: 'question',
      title: 'Confirm',
      html: '<p>Do you want to clear ranks?</p>',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.javaPostDataCall(body, Constants.CLEAR_RANKS).subscribe(response => {
            clearResponse = response;
            resolve(clearResponse);
          }, error => {
            clearResponse = error;
            reject(clearResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (clearResponse.status === 'success') {
          that.getTermSettings();
          Swal({
            type: 'success',
            title: 'Success',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: 'Successfully cleared the ranks.',
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
        } else if (clearResponse.status === 'fail') {
          if (clearResponse.hasOwnProperty('message') && clearResponse.message !== null &&
              clearResponse.message !== '' && clearResponse.message !== undefined) {
            Swal({
              type: 'error',
              title: 'Fail',
              width: 600,
              padding: 80,
              showCancelButton: false,
              showConfirmButton: true,
              html: '<p>Failed to clear ranks because ' + clearResponse.message + ' </p>',
            }).then(function (res) {
              console.log(res);
            }, function (timer) {
              console.log(timer);
            });
          }
        }
      }
    }, function (cancel) {
      console.log(cancel);
    });
  }

  generateRanks(term: any) {
    let generateResponse;
    const that = this;
    const body = {
      outgoing_term_id: term.outgoing_term_id,
      user_id : JSON.parse(localStorage.getItem('epas_user')).user_id
    };
    console.log(body);
    Swal({
      type: 'question',
      title: 'Confirm',
      html: '<p>Do you want to generate ranks?</p>',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.javaPostDataCall(body, Constants.GENERATE_RANKS).subscribe(response => {
            generateResponse = response;
            resolve(generateResponse);
          }, error => {
            generateResponse = error;
            reject(generateResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (generateResponse.status === 'success') {
          that.getTermSettings();
          Swal({
            type: 'success',
            title: 'Success',
            width: 600,
            padding: 80,
            showCancelButton: false,
            showConfirmButton: true,
            html: 'Successfully generated the ranks.',
          }).then(function (res) {
            console.log(res);
          }, function (timer) {
            console.log(timer);
          });
        } else if (generateResponse.status === 'fail') {
          if (generateResponse.hasOwnProperty('message') && generateResponse.message !== null &&
              generateResponse.message !== '' && generateResponse.message !== undefined) {
            Swal({
              type: 'error',
              title: 'Fail',
              width: 600,
              padding: 80,
              showCancelButton: false,
              showConfirmButton: true,
              html: '<p>Failed to generate ranks because ' + generateResponse.message + ' </p>',
            }).then(function (res) {
              console.log(res);
            }, function (timer) {
              console.log(timer);
            });
          }
        }
      }
    }, function (cancel) {
      console.log(cancel);
    });
  }

  canAccessOIA() {
    return this.accessService.canAccessOIA();
  }

  canAccessEC() {
    return this.accessService.canAccessEC();
  }

  ngOnInit() {
    this.getTermSettings();
    this.getProgrammes();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
